import { validationIsEqual } from '../status';
import {
    validateEmail,
    validateName,
    validateNumber,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateNumericString,
    validateDate,
    validateDateOfBirth,
} from '@om/validation';
import {
    RELATIONSHIP_SET_VALUE,
    NAME_SET_VALUE,
    ID_BIRTH_CERTIFICATE_SET_VALUE,
    DATE_OF_ONSET_SET_VALUE,
    DATE_OF_LAST_EPISODE_SET_VALUE,
    PAST_CURRENT_TREATMENT_SET_VALUE,
    setRelationshipValid,
    setNameValid,
    setIdBirthCertificateValid,
    setDateOfOnsetValid,
    setDateOfLastEpisodeValid,
    setPastCurrentTreatmentValid,
} from '../../../actions/afyaImara/medicalHistory';

let prevValidationAction = null;

const date = new Date();
const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
const year = date.getFullYear();

const formattedDate = `${day}/${month}/${year}`;

export const medicalHistoryValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case RELATIONSHIP_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Relationship',
                    min: 2,
                });
                return setRelationshipValid(error);

            case NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Name',
                });
                return setNameValid(error);

            case ID_BIRTH_CERTIFICATE_SET_VALUE:
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'ID Number',
                });
                return setIdBirthCertificateValid(error);

            case DATE_OF_ONSET_SET_VALUE:
                error = validateDate(action.value, {
                    subject: 'Date of Onset',
                    max: formattedDate,
                });
                return setDateOfOnsetValid(error);

            case DATE_OF_LAST_EPISODE_SET_VALUE:
                error = validateDate(action.value, {
                    subject: 'Date of Last Episode',
                    max: formattedDate,

                });
                return setDateOfLastEpisodeValid(error);

            case PAST_CURRENT_TREATMENT_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Past or Current Treatment',
                    min: 2,
                });
                return setPastCurrentTreatmentValid(error);

            
            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
